import { call, all } from 'redux-saga/effects';
import { onGetLimitation } from './saga/getLimitations';
import { onGetPlanConfig } from './saga/getPlanCongfig';

export default function* limitationSaga() {
  yield all([
    call(onGetLimitation),
    call(onGetPlanConfig),
  ]);
}